import React from 'react';
import PropTypes from 'prop-types';
import DatePickerReact from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.min.css';

import style from './DatePicker.module.css';

import './DatePicker.css';

const DatePicker = React.memo(({ minDate = null, selectedDate = null, onChange }) => {
  return (
    <DatePickerReact
      placeholderText="mm/dd/yyyy"
      minDate={minDate}
      selected={selectedDate}
      onChange={onChange}
      className={style.main}
    />
  );
});

DatePicker.propTypes = {
  minDate: PropTypes.instanceOf(Date),
  selectedDate: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
};

export default DatePicker;
